import React, { useState } from "react";
import axios from "axios";

const BASE_API =
  process.env.BASE_API_URL ||
  "https://scanmymenu-nm38.onrender.com/api";

export default function CreateRestaurant() {

  const [formData, setFormData] =
    useState({
      restaurantName: "",
      ownerName: "",
      ownerPhone: "",
      ownerEmail: "",
      restaurantAddress: "",
      phone: "",
      email: "",
      description: "",
      openingTime: "",
      closingTime: "",
      category: "",
      city: "",
      state: "",
      pincode: "",

      // NEW — Owner Login
      ownerLoginEmail: "",
      ownerPassword: ""
    });

  const [logo, setLogo] =
    useState(null);

  const [message, setMessage] =
    useState("");

  const [loading, setLoading] =
    useState(false);

  /*
  =========================
  HANDLE INPUT
  =========================
  */

  const handleChange = (e) => {

    const { name, value } =
      e.target;

    setFormData({
      ...formData,
      [name]: value
    });

  };

  /*
  =========================
  SUBMIT
  =========================
  */

  const handleSubmit =
    async (e) => {

    e.preventDefault();

    try {

      setLoading(true);

      const data =
        new FormData();

      Object.keys(formData)
        .forEach(key => {

          data.append(
            key,
            formData[key]
          );

        });

      if (logo) {

        data.append(
          "logo",
          logo
        );

      }

      const token =
        localStorage.getItem(
          "adminToken"
        );

      const res =
        await axios.post(
          `${BASE_API}/admin/restaurants2`,
          data,
          {
            headers: {
              Authorization:
                `Bearer ${token}`
            }
          }
        );

      if (res.data.success) {

        setMessage(
          "Restaurant & Owner account created successfully ✅"
        );

        console.log(
          "Restaurant ID:",
          res.data.restaurantId
        );

        // Optional reset

        setFormData({
          restaurantName: "",
          ownerName: "",
          ownerPhone: "",
          ownerEmail: "",
          restaurantAddress: "",
          phone: "",
          email: "",
          description: "",
          openingTime: "",
          closingTime: "",
          category: "",
          city: "",
          state: "",
          pincode: "",
          ownerLoginEmail: "",
          ownerPassword: ""
        });

        setLogo(null);

      }

    } catch (error) {

      setMessage(
        error.response?.data?.message ||
        "Failed to create restaurant"
      );

    } finally {

      setLoading(false);

    }

  };

  return (

    <div style={{ padding: "40px" }}>

      <h2>
        Create Restaurant
      </h2>

      <form onSubmit={handleSubmit}>

        {/* Restaurant Info */}

        <input
          name="restaurantName"
          placeholder="Restaurant Name"
          value={formData.restaurantName}
          onChange={handleChange}
          required
        />

        <br /><br />

        <input
          name="ownerName"
          placeholder="Owner Name"
          value={formData.ownerName}
          onChange={handleChange}
          required
        />

        <br /><br />

        <input
          name="ownerPhone"
          placeholder="Owner Phone"
          value={formData.ownerPhone}
          onChange={handleChange}
        />

        <br /><br />

        <input
          name="ownerEmail"
          placeholder="Owner Email"
          value={formData.ownerEmail}
          onChange={handleChange}
        />

        <br /><br />

        <input
          name="restaurantAddress"
          placeholder="Restaurant Address"
          value={formData.restaurantAddress}
          onChange={handleChange}
        />

        <br /><br />

        <input
          name="phone"
          placeholder="Restaurant Phone"
          value={formData.phone}
          onChange={handleChange}
        />

        <br /><br />

        <input
          name="email"
          placeholder="Restaurant Email"
          value={formData.email}
          onChange={handleChange}
        />

        <br /><br />

        <textarea
          name="description"
          placeholder="Description"
          value={formData.description}
          onChange={handleChange}
        />

        <br /><br />

        <label>
          Opening Time:
        </label>

        <input
          type="time"
          name="openingTime"
          value={formData.openingTime}
          onChange={handleChange}
        />

        <br /><br />

        <label>
          Closing Time:
        </label>

        <input
          type="time"
          name="closingTime"
          value={formData.closingTime}
          onChange={handleChange}
        />

        <br /><br />

        <input
          name="category"
          placeholder="Category"
          value={formData.category}
          onChange={handleChange}
        />

        <br /><br />

        <input
          name="city"
          placeholder="City"
          value={formData.city}
          onChange={handleChange}
        />

        <br /><br />

        <input
          name="state"
          placeholder="State"
          value={formData.state}
          onChange={handleChange}
        />

        <br /><br />

        <input
          name="pincode"
          placeholder="Pincode"
          value={formData.pincode}
          onChange={handleChange}
        />

        <br /><br />

        {/* Logo */}

        <label>
          Upload Logo:
        </label>

        <input
          type="file"
          onChange={(e) =>
            setLogo(
              e.target.files[0]
            )
          }
        />

        <br /><br />

        {/* Owner Login Section */}

        <h3>
          Owner Login Details
        </h3>

        <input
          name="ownerLoginEmail"
          placeholder="Login Email"
          value={formData.ownerLoginEmail}
          onChange={handleChange}
          required
        />

        <br /><br />

        <input
          type="password"
          name="ownerPassword"
          placeholder="Password"
          value={formData.ownerPassword}
          onChange={handleChange}
          required
        />

        <br /><br />

        <button
          type="submit"
          disabled={loading}
        >
          {loading
            ? "Creating..."
            : "Create Restaurant"}
        </button>

      </form>

      <p>
        {message}
      </p>

    </div>

  );

}